export default __webpack_public_path__ + "static/media/swimClass.204dd684.svg";